import React from "react";
import MessageLog from "./MessageLog";
import PageComponent from "../../../page/PageComponent";
import EntityMessageLogService from "../../../../../services/EntityMessageLogService";
import EntityMessageLogTypeService from "../../../../../services/EntityMessageLogTypeService";
import { constants } from "../../../../../utils/Constants";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import CommonUtil from "../../../../../utils/CommonUtil";

class MessageLogContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.entityMessageLogService = new EntityMessageLogService();
    this.entityMessageLogTypeService = new EntityMessageLogTypeService();

    this.state = {
      content: [],
      sortInfo: {
        orderBy: "id",
        direction: "desc"
      },
      messageLogType: {}
    };
  }

  componentDidMount() {
    this.loadMessageLogsTypes();
    this.loadMessageLogs(this.props.entity);
  }

  getComponentTitle = () => {
    return undefined;
  };

  onTypesLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      const types = dataContent;
      const selectedMessageLogType = types.find(
        item => item.id === constants.DEFAULT_MESSAGE_ID
      );
      this.setState({
        additionalTypes: types,
        selectedMessageLogType: selectedMessageLogType
      });
    }
  };

  loadMessageLogsTypes = () => {
    const sortInfo = {
      orderBy: "id",
      direction: "asc"
    };

    this.prepareCall(
      this.entityMessageLogTypeService.getEntities(
        activeFilterPageInfo,
        sortInfo,
        this.onTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDataLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      this.setState({ content: dataContent });
    }
  };

  loadMessageLogs = entity => {
    const url = entity._links.messgeLogsCompactView.href;
    this.prepareCall(
      this.entityMessageLogService.getEntityMessageLogsUrlPageable(
        url,
        undefined,
        this.state.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onMessageSave = data => {
    this.loadMessageLogs(this.props.entity);
  };

  saveMessageLog = message => {
    this.prepareCall(
      this.entityMessageLogService.postEntity(
        message,
        this.onMessageSave,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onMessageSubmit = comment => {
    const message = {
      ...comment,
      entity: this.props.entity,
      messageLogType: this.state.selectedMessageLogType
    };
    this.saveMessageLog(message);
  };

  onMessageLogTypeChange = event => {
    this.setState({
      selectedMessageLogType: event.target.value
    });
  };

  render() {
    return (
      <MessageLog
        content={this.state.content}
        onMessageSubmit={this.onMessageSubmit}
        defaultType={this.state.selectedMessageLogType}
        additionalTypes={this.state.additionalTypes}
        onMessageLogTypeChange={this.onMessageLogTypeChange}
      />
    );
  }
}

export default MessageLogContainer;
